import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { ReactComponent as ArticlesAndGuidesIcon } from "../../../../assets/img/icons/articlesAndGuides.svg";
import { ReactComponent as StepByStepVideosIcon } from "../../../../assets/img/icons/stepByStepVideos.svg";
import { ReactComponent as TrackProgressIcon } from "../../../../assets/img/icons/trackYourProgress.svg";
import { ReactComponent as UnlimitedRecipesIcon } from "../../../../assets/img/icons/unlimitedRecipes.svg";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { useHistory } from "react-router";

import {
  ModalPageBody,
  ModalPageCopy,
  ModalPageFooter,
  ModalPageHeading,
  ModalPageWrapper,
  ModalPageHeader,
} from "../../../organisms/ModalPage";
import "./OnARoll.scss";
import { ProgrammeProps } from "../Props";

export interface OnARollPageData {
  pointer: string;
}

interface OnARollProps extends ProgrammeProps {
  onARollPageData: OnARollPageData;
  pageRedirectionLogicOrNextStepUrl: () => void | string;
}

const OnARoll: React.FC<OnARollProps> = ({
  programmeTitle,
  pageRedirectionLogicOrNextStepUrl,
  onARollPageData,
}) => {
  let history = useHistory();
  const pageTitle = `On a roll | ${programmeTitle} | ${pageTitleSuffix}`;

  const handleContinue = () => {
    if (typeof pageRedirectionLogicOrNextStepUrl === "string") {
      history.push(pageRedirectionLogicOrNextStepUrl);
    } else {
      pageRedirectionLogicOrNextStepUrl();
    }
  };

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
    });
  }, [pageTitle]);

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
      </Helmet>
      <ModalPageWrapper>
        <ModalPageBody hasStickyFooter={false}>
          <ModalPageHeader
            backButtonOnClick={() => {
              history.goBack();
            }}
          />
          <ModalPageHeading>You're on a roll</ModalPageHeading>
          <ModalPageCopy>
            <p>
              We feel like we know you better already! You're moments away from starting your journey with
              gloji and here are just a few of the things you have to look forward to.
            </p>
            <div className="list-with-icon">
              <StepByStepVideosIcon />
              <p>Step-by-step videos</p>
            </div>
            <div className="list-with-icon">
              <ArticlesAndGuidesIcon />
              <p>Articles and guides picked just for you</p>
            </div>
            <div className="list-with-icon">
              <UnlimitedRecipesIcon />
              <p>{onARollPageData.pointer}</p>
            </div>
            <div className="list-with-icon">
              <TrackProgressIcon />
              <p>An easy way to track your progress</p>
            </div>
          </ModalPageCopy>
        </ModalPageBody>
        <ModalPageFooter hasStickyFooter={false}>
          <Button onClick={handleContinue} variant="contained" color="primary">
            Continue
          </Button>
        </ModalPageFooter>
      </ModalPageWrapper>
    </>
  );
};

export default OnARoll;
